import { Button, Tooltip } from '@mui/material';
// context
import { useAuthContext } from '../../auth/useAuthContext';
// locales
import { useLocales } from '../../locales';

// ----------------------------------------------------------------------

export default function AuthLoginForm() {
  const { redirectToOAuth } = useAuthContext();
  const { translate } = useLocales();

  const onOAuthLogin = async () => {
    try {
      if(window.location.hash && window.location.hash.startsWith("#access_token=")){
        console.log("[AuthLoginForm] Token ok") //? automatique.
      } else {
        // console.log("[AuthLoginForm] Pas de token, go to OAuth")
        await redirectToOAuth();
      }
    } catch (error) {
      console.error("[AuthLoginForm] ", error);
    }
  };

  return (
    <Tooltip title={translate('login.tooltip')} placement="bottom">
      <Button onClick={onOAuthLogin} variant="contained" sx={{backgroundColor: "#1b85e0", textTransform: "none"}}>
        {translate('login.button')}
      </Button>
    </Tooltip>
    
  );
}
